<page-title [title]="title"></page-title>

<p *ngIf="currentUser.type == 'organization'">Aqui você pode consultar e gerenciar as suas consultas.</p>

<form class="row">
  <div class="col-xs-12 col-md-3">
    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>Consulta/Exame</mat-label>
      <mat-select [(value)]="encounterType" (selectionChange)="onTipoChange()">
        <mat-option *ngFor="let item of filterTipos; let i = index; trackBy: trackByIndex" [value]="i">
          {{ item }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="col-xs-12 col-md-9">
    <div class="search-container">
      <mat-form-field class="example-full-width" appearance="outline">
        <mat-label>Buscar agendamento</mat-label>
        <input
          type="text"
          matInput
          [formControl]="buscarScheduleControl"
          (focus)="onInputFocus()"
          (blur)="onInputBlur()"
          placeholder="Busque por: nome do paciente, especialista ou procedimento"
        />

        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>

      <mat-card *ngIf="showAutocompletePanel" class="autocomplete-panel">
        <mat-list>
          <mat-list-item
            *ngFor="let suggestion of autocompleteSuggestions; trackBy: trackBySuggestion"
            (mousedown)="selectSuggestion(suggestion)"
            class="suggestion-item"
          >
            <mat-icon matListIcon>search</mat-icon>
            <div matLine>{{ suggestion }}</div>
          </mat-list-item>
        </mat-list>
      </mat-card>
    </div>
  </div>
</form>

<div *ngIf="buscarSchedule && buscarSchedule.length >= minSearchLength" class="results-count">
  {{ atendimentosFiltroList.length }} agendamento{{ atendimentosFiltroList.length !== 1 ? 's' : '' }} encontrado{{
    atendimentosFiltroList.length !== 1 ? 's' : ''
  }}
</div>

<mat-tab-group animationDuration="0ms" [preserveContent]="true" (selectedTabChange)="onTabChange($event)">
  <mat-tab *ngFor="let tab of tabs; trackBy: trackByTab" [label]="tab.title">
    <ng-container *ngIf="tab.id === activeTabId">
      <div class="col-xs-12 schedule-card-wrapper" *ngFor="let encounter of getContent(tab.id); trackBy: trackByEncounter">
        <mat-card style="padding: 10px; margin-top: 20px">
          <div class="col-md-12">
            <h3 *ngIf="!encounter.byOrderInfo?.isByOrder">
              {{ layout.dateTimeFormat(encounter.startDate) }} - {{ encounter.type }}
              <mat-chip color="accent" class="float-right" [ngClass]="getColorStatus(encounter.status, false, encounter.status_payment)">
                {{ getTextStatus(encounter.status) }}
              </mat-chip>
            </h3>

            <h3 *ngIf="encounter.byOrderInfo?.isByOrder">
              {{ layout.dateFormat(encounter.startDate) }} - {{ encounter.type }}
              <mat-chip
                color="accent"
                class="float-right"
                [ngClass]="getColorStatus(encounter.status, encounter.byOrderInfo?.isByOrder, encounter.status_payment)"
              >
                {{ getTextStatus(encounter.status, encounter.byOrderInfo?.isByOrder) }}
              </mat-chip>
            </h3>
          </div>

          <div class="col-xs-12 col-md-8">
            <div class="content" *ngIf="encounter.type == 'Consulta'">
              <b>Procedimento: </b> {{ encounter.name }} <br />
              <b>Especialista: </b> {{ encounter.practitioner?.name }} <br />
              <b>Paciente: </b>{{ encounter.patient?.name }}
            </div>

            <div class="content" *ngIf="encounter.type == 'Exame'">
              <b>Procedimento: </b> {{ encounter.name }} <br />
              <b>Especialista: </b> {{ encounter.practitioner?.name }} <br />
              <div *ngIf="encounter.organization"><b>Paciente: </b> {{ encounter.patient?.name }}</div>
            </div>

            <div class="content"><b>Forma de agendamento:</b> {{ encounter?.scheduling_method }}</div>

            <div class="content" *ngIf="encounter.scheduling_method == 'CONVENIO'">
              <b>Status de Aprovação:</b> {{ encounter.agreement_approved ? 'Aprovado' : 'Pendente Aprovacao' }}
            </div>

            <div class="content" *ngIf="encounter.secretary?.secretary_id"><b>Agendado por:</b> {{ encounter.secretary?.name }}</div>
          </div>

          <div class="col-xs-12 col-md-12">
            <div class="actions">
              <button *ngIf="tab.id == 1" mat-button (click)="editStatus(encounter)" color="primary">Alterar status</button>

              <!-- Não use [disabled]="loading" aqui. O loadMore não deve mexer nos botões dos cards. -->
              <button mat-flat-button color="primary" (click)="openComponentDialogScheduleDetailForm(encounter)">Ver detalhes</button>
            </div>
          </div>
        </mat-card>
      </div>

      <div *ngIf="!loadingInitial && buscarSchedule && buscarSchedule.length >= minSearchLength && getContentLength(tab.id) === 0" class="no-results">
        <mat-icon>search_off</mat-icon>
        <p>Nenhum agendamento encontrado para "{{ buscarSchedule }}"</p>
      </div>

      <div *ngIf="!loadingInitial && encounters.length === 0" class="no-results">
        <mat-icon>calendar_month</mat-icon>
        <p>Ainda não existem agendamentos encontrados para a instituição</p>
      </div>

      <div class="load-more-footer col-md-12" style="min-height: 78px; padding-top: 14px">
        <div class="loading-more" [style.visibility]="loadingMore ? 'visible' : 'hidden'">
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
          <small>Carregando mais atendimentos...</small>
        </div>

        <div class="no-results end-list" [style.display]="!loadingInitial && !hasMore && encounters.length > 0 ? 'block' : 'none'">
          <small>Fim da lista</small>
        </div>
      </div>
    </ng-container>
  </mat-tab>
</mat-tab-group>
